<sim-basic-material-dialog
	(closeClicked)="closeDialog()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cube', fontSet: 'fad'}"
	[headerText]="T.SCENARIO_CREATE_EXAM_SESSION | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-component-loading-container [isLoading]="isLoading()" [showBackDrop]="true" loadingIcon="fad fa-cube" />

		<mat-stepper #sessionStepper [linear]="true" labelPosition="bottom" orientation="horizontal">
			@if (!isLoading()) {
				<ng-template matStepperIcon="edit">
					<mat-icon fontIcon="fa-check" fontSet="fal" inline />
				</ng-template>

				<!--STEP 1-->
				<mat-step
					[completed]="stateService.step1Form.valid"
					[editable]="true"
					[stepControl]="stateService.step1Form"
					errorMessage="error"
				>
					<ng-template matStepLabel>
						{{ T.CREATE_SESSION_DIALOG_EXAM_METADATA | translate }}
					</ng-template>
					<ng-template matStepContent>
						<sim-exam-session-step1 [eventEndDate]="data.eventEndDate" [eventStartDate]="data.eventStartDate" />
					</ng-template>
				</mat-step>

				<!--STEP 2-->
				<mat-step
					[completed]="stateService.step2Form.valid"
					[editable]="true"
					[stepControl]="stateService.step2Form"
					errorMessage="error"
				>
					<ng-template matStepLabel>
						Stations
						@if (!!stateService.step2Form) {
							@if (stateService.step2Form?.length >= 2) {
								({{ stateService.step2Form?.length }} Stations)
							}
						}
					</ng-template>
					<ng-template matStepContent>
						<sim-exam-session-step2 />
					</ng-template>
				</mat-step>

				<!--STEP 3-->
				<mat-step
					[completed]="stateService.step3Form.valid"
					[editable]="true"
					[stepControl]="stateService.step3Form"
					errorMessage="error"
				>
					<ng-template matStepLabel> Student Selection </ng-template>
					<ng-template matStepContent>
						<sim-exam-session-step3 />
					</ng-template>
				</mat-step>
			}
		</mat-stepper>
	</ng-container>

	<ng-container actions>
		<!--AUTOSAVE-->
		<sim-autosave-widget
			[promise]="stateService.savePromise"
			[timestamp]="stateService.session?.lastUpdateTime"
			[warningMessage]="saveWarning"
		/>

		<!--NAV BUTTONS-->
		@if (stepper()?.selectedIndex !== 2) {
			<sim-button
				(onClick)="stepper().next()"
				[disabled]="!stepper().selected?.completed"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-step-forward'}"
				[label]="T.BUTTON_NEXT"
				color="accent"
			/>
		} @else {
			<sim-button
				(onClick)="closeDialog()"
				[disabled]="currentStepForm()?.invalid"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_FINISH"
				color="accent"
			/>
		}
	</ng-container>
</sim-basic-material-dialog>
